import {
  Component,
  OnInit,
  OnDestroy,
  NgZone,
  ViewChild,
  Input,
} from "@angular/core";

import { Subscription } from "rxjs";

import { ModalDirective } from "ngx-bootstrap/modal";

import {
  AuthorizationService,
  EventSubscriptionService,
  EquipmentService,
  Equipment,
  ModelService,
  Model,
  PoweredByService,
  PoweredBy,
  ToastrService,
} from "./../../../../shared/index";

@Component({
  selector: "equipment-manipulate",
  templateUrl: "./equipment-manipulate.html",
  standalone: false,
})
export class EquipmentManipulateComponent implements OnInit, OnDestroy {
  @ViewChild("equipmentManipulate") modal: ModalDirective;
  @Input("live") live = true;
  public equipment: Equipment = new Equipment();
  public models: Model[] = [];
  public poweredBys: PoweredBy[] = [];
  public edit = true;

  private subscriptions: Subscription[] = [];
  private rootPoweredById: number;
  private rootModelId: number;

  constructor(
    private _ngZone: NgZone,
    private _equipmentService: EquipmentService,
    private _modelService: ModelService,
    private _poweredByService: PoweredByService,
    private _toastrService: ToastrService
  ) {
    //this._eventService.configure(this)
    //    .Add(this._classificationService.classificationChange.subscribe((info: any) => this.onClassificationChange(info)))
    //    .Add(this._modelService.manipulateModel.subscribe((info: any) => this.onManipulateModel(info)))
    this.subscriptions.push(
      this._poweredByService.poweredByChange.subscribe((info: any) =>
        this.onPoweredByChange(info)
      )
    );
    this.subscriptions.push(
      this._modelService.modelChange.subscribe((info: any) =>
        this.onModelChange(info)
      )
    );
    this.subscriptions.push(
      this._equipmentService.manipulateEquipment.subscribe((info: any) =>
        this.onManipulateEquipment(info)
      )
    );
    this.subscriptions.push(
      this._equipmentService.equipmentChange.subscribe((info: any) =>
        this.onEquipmentChange(info)
      )
    );
  }

  public close() {
    this.modal.hide();
  }

  public save(another: boolean = false) {
    if (Number(localStorage.getItem("Lock")) == 1) {
      this._toastrService.displayToastrMessage(
        "error",
        localStorage.getItem("Msg"),
        "Environment Status!"
      );
      return;
    }
    if (this.edit) {
      this._equipmentService.save(this.equipment);
    } else {
      this._equipmentService.create(this.equipment);
    }
    //this._equipmentService.GetEquipmentForModelAndPoweredByStaging(this.equipment.ModelId, this.equipment.PoweredById);

    if (!another) {
      this.modal.hide();
    }
  }

  private onModelChange(models: Model[]): void {
    this._ngZone.run(() => {
      this.models = models;
    });
  }

  private onEquipmentChange(info: any): void {
    if (this.live) {
      if (this.rootModelId != undefined && this.rootPoweredById != undefined) {
        this._equipmentService.getEquipmentForModelAndPoweredBy(
          this.rootModelId,
          this.rootPoweredById
        );
        this._equipmentService.getEquipmentForModelAndPoweredBy(
          this.equipment.ModelId,
          this.equipment.PoweredById
        );
        this._poweredByService.getPoweredBysByModel(this.rootModelId);
        this._poweredByService.getPoweredBysByModel(this.equipment.ModelId);
        this._modelService.equipmentCountChange.emit(this.rootModelId);
        this._modelService.equipmentCountChange.emit(this.equipment.ModelId);
      }
    } else {
      if (this.rootModelId != undefined && this.rootPoweredById != undefined) {
        //this._poweredByService.getPoweredBysByModelStaged(this.rootModelId);
        //this._poweredByService.getPoweredBysByModelStaged(this.equipment.ModelId);
        this._equipmentService.GetEquipmentForModelAndPoweredByStaging(
          this.rootModelId,
          this.rootPoweredById
        );
        //this._equipmentService.GetEquipmentForModelAndPoweredByStaging(this.equipment.ModelId, this.equipment.PoweredById);
        this._modelService.equipmentCountChange.emit(this.rootModelId);
        //this._modelService.equipmentCountChange.emit(this.equipment.ModelId);
      }
      if (this.rootModelId != undefined && this.rootPoweredById == undefined) {
        this._poweredByService.getPoweredBysByModelStaged(this.rootModelId);
      }
    }
  }

  private onManipulateEquipment(equipment: Equipment): void {
    this.equipment = equipment;
    this.rootModelId = equipment.ModelId;
    this.rootPoweredById = equipment.PoweredById;
    if (equipment.Equipment_ID != undefined) {
      this.edit = true;
    } else {
      this.edit = false;
    }
    this.modal.show();
  }
  private onPoweredByChange(poweredBys: PoweredBy[]): void {
    this._ngZone.run(() => {
      this.poweredBys = [];
      this.poweredBys = poweredBys;
    });
  }
  ngOnInit(): void {
    if (this.live) this._poweredByService.getPoweredBys();
    else this._poweredByService.getPoweredBysStaged();
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }
}
